<!-- period-picker.component.html -->

<div class="period">
  <div class="common-drop">
    <div class="key">{{ label }}<span class="asterisk">*</span></div>
    <mat-form-field appearance="outline">
      <mat-select
        [(ngModel)]="selectedDate.year"
        [(value)]="selectedDate.year"
        (selectionChange)="updateYear()"
        placeholder="Year"
      >
        <mat-option
          *ngFor="let year of currentlyAvailablePeriodData['year']"
          [value]="year"
          >{{ year }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="price === 'Post Code Plan'" appearance="outline">
      <mat-select
        [(ngModel)]="selectedDate.quarter"
        [(value)]="selectedDate.quarter"
        (selectionChange)="updateQuarter()"
        placeholder="Quarter"
      >
        <mat-option
          *ngFor="let quarter of currentlyAvailablePeriodData['quarter']"
          [value]="quarter"
          >{{ quarter }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field
      *ngIf="
        price === 'PCM' ||
        price === 'MPI' ||
        price === 'Monthly' ||
        price === 'Weekly'
      "
      appearance="outline"
    >
      <mat-select
        [(ngModel)]="selectedDate.month"
        [(value)]="selectedDate.month"
        (selectionChange)="updateMonth()"
        placeholder="Month"
      >
        <mat-option
          *ngFor="let month of currentlyAvailablePeriodData['month']"
          [value]="month"
          >{{ monthsMapper[month] ? monthsMapper[month] : month }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field
      *ngIf="price === 'PCM' || price === 'Weekly'"
      appearance="outline"
    >
      <mat-select
        [(ngModel)]="selectedDate.week"
        [(value)]="selectedDate.week"
        (selectionChange)="updateWeek()"
        placeholder="Week"
      >
        <mat-option
          *ngFor="let week of currentlyAvailablePeriodData['week']"
          [value]="week"
          >{{ week }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
</div>
